<template>
  <textarea class="rumie-text-area" :value="value" @input="(e) => $emit('input', e.target.value)" ></textarea>
</template>

<script>
export default {
  props: {
    value: [String, Number]
  }
}
</script>


<style scoped>
.rumie-text-area {
  resize: none;
  border: none;
  width: 100%;
  box-sizing: border-box;
  background: var(--grey-lighter);
  border-radius: var(--border-radius-md);
  padding: var(--spacing-4);
}
</style>
